import React, { useState } from 'react';
import {
    Form,
    Input,
    Modal,
    Message,
    Typography,
} from '@arco-design/web-react';
import { updatePassword } from '@/request/api';
import { clearKouziAccessToken, clearKouziRefreshToken } from '@/utils/index';
const FormItem = Form.Item;
interface ForceChangePasswordModalProps {
    visible: boolean;
}
const ForceChangePasswordModal: React.FC<ForceChangePasswordModalProps> = ({
    visible,
}) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const handleSubmit = async () => {
        try {
            await form.validate();
            const values = form.getFieldsValue();
            setLoading(true);
            updatePassword({
                oldPassword: values.oldPassword,
                password: values.password,
            })
                .then((res) => {
                    // 只有 code=1000 才是成功
                    if (res.code === 1000) {
                        const { msg } = res;
                        Message.success(msg || '密码修改成功');
                        // 清除所有登录相关的 localStorage
                        localStorage.removeItem('userToken');
                        localStorage.removeItem('userStatus');
                        localStorage.removeItem('userInfo');
                        localStorage.removeItem('userRole');
                        localStorage.removeItem('sysRoleId');
                        localStorage.removeItem('editCourseListIds');
                        clearKouziAccessToken();
                        clearKouziRefreshToken();
                        // 跳转到登录页
                        setTimeout(() => {
                            window.location.href = '/login';
                        }, 1000);
                    } else {
                        // code 不是 1000，视为失败
                        const errorMsg = res?.msg || '密码修改失败，请重试';
                        Message.error(errorMsg);
                        setLoading(false);
                    }
                })
                .catch((e) => {
                    console.log(e);
                    // 错误信息可能在 e.msg 或 e.data?.msg 中
                    const errorMsg = e?.msg || e?.data?.msg || '密码修改失败，请重试';
                    Message.error(errorMsg);
                    setLoading(false);
                });
        } catch (e) {
            // 表单验证失败
        }
    };
    return (
        <Modal
            title="密码过于简单，请修改密码"
            visible={visible}
            onOk={handleSubmit}
            onCancel={() => {
                // 不允许关闭，必须修改密码
                Message.warning('请先修改密码');
            }}
            closable={false}
            maskClosable={false}
            okText="确认修改"
            cancelButtonProps={{ style: { display: 'none' } }}
            confirmLoading={loading}
        >
            <Form
                autoComplete="off"
                form={form}
                layout="vertical"
            >
                <FormItem
                    label="旧密码"
                    field="oldPassword"
                    rules={[
                        { required: true, message: '请输入旧密码' },
                    ]}
                >
                    <Input.Password placeholder="请输入旧密码" />
                </FormItem>
                <FormItem
                    label="新密码"
                    field="password"
                    rules={[
                        { required: true, message: '请输入新密码' },
                        { minLength: 8, message: '新密码至少8位' },
                    ]}
                >
                    <Input.Password placeholder="请输入新密码（至少8位）" />
                </FormItem>
                <FormItem
                    label="确认新密码"
                    field="confirmPassword"
                    rules={[
                        { required: true, message: '请再次输入新密码' },
                        {
                            validator: (value, cb) => {
                                const password = form.getFieldValue('password');
                                if (value !== password) {
                                    return cb('两次输入的密码不一致');
                                }
                                return cb();
                            },
                        },
                    ]}
                >
                    <Input.Password placeholder="请再次输入新密码" />
                    <Typography.Text style={{ fontSize: '12px', marginTop: '4px', display: 'block', color: '#f53f3f' }}>
                        建议包含大小写字母、数字、特殊符号，且长度不少于8位
                    </Typography.Text>
                </FormItem>
            </Form>
        </Modal>
    );
};
export default ForceChangePasswordModal;